export enum HotspotCardSizeEnum {
  MEDIUM = 'medium',
  LARGE = 'large'
}
